import { Split, SplitPercentage } from "../models/Split";
import { host, getRequest, putRequest, patchRequest, postRequest, deleteRequest } from "./apiService";

export async function loadSplits() {
	return getRequest<Split[]>(
		`${host}/api/split`
	);
}

export async function getSplitPercentages(id: string) {
	return getRequest<SplitPercentage[]>(
		`${host}/api/split/${id}`
	);
}

export async function addSplit(newSplit: Split) {
	delete (newSplit as Partial<Split>).id;
	newSplit.splitPercentages?.forEach(detail => {
		delete (detail as Partial<SplitPercentage>).splitId;
	});

	return postRequest<Split | undefined>(
		`${host}/api/split`, newSplit
	);
}

export async function updateSplit(split: Split) {
	return patchRequest<void>(
		`${host}/api/split/${split.id}`, split
	);
}

export async function deleteSplit(id: string) {
	return deleteRequest(
		`${host}/api/split/${id}`
	);
}

export async function saveSplitPercentages(id: string, data: SplitPercentage[]) {
	return putRequest<void>(
		`${host}/api/split/${id}/percentages`, data
	);
}